import { render } from "./mainLoader.vue?vue&type=template&id=5b5c90d8&scoped=true"
import script from "./mainLoader.vue?vue&type=script&lang=js"
export * from "./mainLoader.vue?vue&type=script&lang=js"

import "./mainLoader.vue?vue&type=style&index=0&id=5b5c90d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5c90d8"]])

export default __exports__